import { Pipe, PipeTransform } from '@angular/core';

/**
 * @deprecated this pipe was only temporary solution for enable "strict" option in typescript,
 *              it should be deleted where possible.
 */
@Pipe({ name: 'notNull', pure: true })
export class NotNullPipe implements PipeTransform {
  transform<T>(value: T): Exclude<T, undefined | null> {
    return value as Exclude<T, undefined | null>;
  }
}
